
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import AlacakTuruPicker from "@/components/pickers/AlacakTuruPicker.vue";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Faizler from "@/components/forms/Faizler.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import Kur from "@/components/inputs/Kur.vue";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {alacakKurunuEsitle} from "@/helpers/TakipTarihliKurHelper";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";

@Component({
  components: {
    Kur,
    ParaBirimiPicker,
    DovizTakipSekliPicker,
    AlacakTuruPicker,
    Tutar,
    Dates,
    Faizler,
    FormWrapper,
  },
})
export default class TazminatAlacakKalemiForm extends Mixins(ObjectInputMixin) {
  @Prop({required: true}) takipId!: number;
  @Prop() takipTipiId!: number;
  @Prop() alacakBelgeTuruId!: number;
  @Prop({default: false}) hideButtons!: boolean;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop() paraBirimleri!: Array<ParaBirimi>;
  @Prop() alacak!: AlacakEntity;

  AlacakBelgeTuru = AlacakBelgeTuru;
  ParaBirimiTuru = ParaBirimi;
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  readonlyParaBirimi = false;
  kurElleDegisti = false; // Kur kutusuna kullanıcı yazdı mı: alacak ekranına yansıtma buna bağlı

  get isIlamliTakip(): boolean {
    return this.$helper.isIlamliTakipFromTakipStore();
  }

  async save(){
    if (this.alacak.id){
      this.localValue.alacak_kalemi_alani_id = 1
      this.localValue.alacak_id = this.alacak.id

      if (this.alacak.alacak_belge_turu_id !== this.AlacakBelgeTuru.apartman_alacagi){
        this.localValue.gecikme_tazminati_mi = false
      }else{
        if (this.localValue.gecikme_tazminati_mi){
          this.localValue.gecikme_tazminati_mi = true
        }else{
          this.localValue.gecikme_tazminati_mi = false
        }
      }

      if (this.localValue.id){
        if (this.localValue.elle_faiz_oran_mi) {
          if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
            this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
            this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
            this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
          }
        }
        await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id,this.localValue);
        this.kuruAlacagaYansit();
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }else{
        await this.$http.post('/api/v1/alacak/' + this.alacak.id + '/alacak-kalemi',this.localValue);
        this.kuruAlacagaYansit();
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }
    }else{
      this.$emit("addAsilAlacak",this.localValue);
      this.$emit("onSuccess");
    }
  }

  @Watch("tarih")
  onVadeTarihiChange() {
    this.localValue.faiz_baslangic_tarihi = this.tarih;
  }

  get tarih() {
    if (this.localValue.vade_tarihi) {
      return this.localValue.vade_tarihi;
    } else if (this.localValue.ibraz_tarihi) {
      return this.localValue.ibraz_tarihi;
    }
  }

  addParaBirimi() {
    if (this.localValue.takip_tarihli_kurlar &&
        this.localValue.para_birimi_id != ParaBirimi.TRY &&
        !this.localValue.takip_tarihli_kurlar.find((kur:any) => kur.para_birimi_id == this.localValue.para_birimi_id)) {
      let kur = new TakipTarihliKurEntity();
      kur.para_birimi = this.localValue.para_birimi;
      kur.para_birimi_id = this.localValue.para_birimi_id;
      kur.tutar = null;
      this.localValue.takip_tarihli_kurlar.push(kur);
    }
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY) {
      delete this.localValue.doviz_kur_tarihi;
      this.localValue?.asil_alacaklar?.forEach((asilAlacak: AlacakKalemiEntity) => {
        asilAlacak.para_birimi_id = this.paraBirimi.TRY;
        asilAlacak.para_birimi = this.paraBirimleri.find((paraBirimi: any) => (paraBirimi.id == this.paraBirimi.TRY));
      });
    }
    this.addParaBirimi();
    this.input();
  }

  get alacakKalemiRules() {
    if (this.localValue.aciklama) {
      if (this.localValue.aciklama.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return true;
  }

  @Watch("aciklama")
  onAciklamaChange() {
    this.localValue.aciklama = this.aciklama;
    this.input();
  }

  get aciklama() {
    if (this.localValue.alacak_kalemi_turu) {
      return this.localValue.alacak_kalemi_turu.isim + " Alacağı";
    }
  }
  private updateParaBirimiState() {
    const paraBirimiId = this.alacak.para_birimi_id;
    const dovizKurTarihi = this.alacak.doviz_kur_tarihi;
    const isForeignCurrency = paraBirimiId !== this.paraBirimi.TRY;
    this.readonlyParaBirimi = false;
    if (!isForeignCurrency) {
      this.localValue.para_birimi_id = this.paraBirimi.TRY;
      return;
    }
    switch (dovizKurTarihi) {
      case DovizTakipSekli.tahsilat:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
      case DovizTakipSekli.vade:
      case DovizTakipSekli.takip:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
    }
  }

  @Watch('alacak.para_birimi_id')
  onAlacakParaBirimiChange() {
    this.updateParaBirimiState();
  }

  @Watch('alacak.doviz_kur_tarihi')
  onAlacakDovizKurTarihiChange() {
    this.updateParaBirimiState();
    this.input();
  }

  // Kayıtlı alacakta kalemin kuru kaydedildi: alacak formu eski değeri gösterip Kaydet'inde DB'ye geri yazmasın.
  // Yalnız kullanıcı kur kutusunu değiştirdiyse: düzenleme diyaloğu GET yanıtıyla dolar, dokunulmamış (DB'deki)
  // kur alacak ekranındaki kaydedilmemiş düzenlemeyi ezmesin.
  kuruAlacagaYansit() {
    if (!this.kurElleDegisti) {
      return;
    }
    alacakKurunuEsitle(this.alacak.takip_tarihli_kurlar, this.localValue.takip_tarihli_kurlar, this.localValue.para_birimi_id);
  }

  // Kaydedilmemiş alacakta yeni kalem alacağın kur listesini paylaşır (takip + para birimi başına tek kur);
  // ayrı liste ikinci kur satırı açıyordu. Liste kalemden sonra gelebilir, o yüzden izleyici de var.
  // Aynı listeyse çıkılır: input() ebeveyni yeniden kurup izleyiciyi tekrar tetikler, korumasız döngü olur.
  @Watch('alacak.takip_tarihli_kurlar')
  alacakKurlariniPaylas() {
    const ortak = this.alacak?.takip_tarihli_kurlar;
    if (this.localValue.id || this.alacak?.id || !Array.isArray(ortak) || this.localValue.takip_tarihli_kurlar === ortak) {
      return;
    }
    // Yeni nesne: mounted'taki boş liste düz atandı (reaktif değil), $set onu yalnız üzerine yazardı.
    this.localValue = Object.assign({}, this.localValue, {takip_tarihli_kurlar: ortak});
    // Para birimi seçici asenkron dolar; boşken ortak listeye para birimsiz sahte satır düşerdi.
    if (this.localValue.para_birimi_id) {
      this.addParaBirimi();
    }
    this.input();
  }

  mounted(){
    this.updateParaBirimiState();
    if (this.localValue.id){
      this.localValue.takip_tarihli_kurlar = this.takipTarihliKurlar;

    }else{
      this.localValue.takip_tarihli_kurlar = []
      this.alacakKurlariniPaylas();
    }
  }


}
